<template>
    <transition name="fadeMenu">
        <div v-if="menuIsOpen" class="menu-mobile" @click="closeMenu">
            <nav>
                <div class="close">
                    <div @click="close">
                        <svg-icon icon="close"></svg-icon>
                    </div>
                </div>
                <ul>
                    <li>
                        <a href="/">Início</a>
                    </li>
                    <li>
                        <a @click="noticiaDropdown = !noticiaDropdown"
                            >Notícias</a
                        >
                        <div
                            :class="
                                !noticiaDropdown
                                    ? 'disable'
                                    : 'menu-mobile-dropdown'
                            "
                        >
                            <a href="/noticias/noticias-ugt">UGT-SP Notícias</a>
                            <a href="/noticias/palavra-do-presidente"
                                >Palavra do Presidente</a
                            >
                            <a href="/noticias/comentario-do-diretor"
                                >Comentário do Diretor</a
                            >
                        </div>
                    </li>
                    <li>
                        <a
                            @click="
                                intitucioanlDropdown = !intitucioanlDropdown
                            "
                            >Institucional</a
                        >
                        <div
                            :class="
                                !intitucioanlDropdown
                                    ? 'disable'
                                    : 'menu-mobile-dropdown'
                            "
                        >
                            <a href="/institucional/carta-de-tupa">Carta de Tupã</a>
                            <a href="/institucional/diretoria">Diretoria</a>
                            <a href="/institucional/historia">História</a>
                            <a href="/institucional/valores">Missão, Visão e Valores</a>
                            <a href="/institucional/presidente">Presidente</a>
                        </div>
                    </li>
                    <li>
                        <a href="/publicacoes">Publicações</a>
                    </li>
                    <li>
                        <a href="/sistema">Emissão de Boletos</a>
                    </li>
                    <li>
                        <a href="/contato">Contato</a>
                    </li>
                    <li class="search-bar">
                        <div class="flex rounded-lg bg-white">
                            <input type="text" placeholder="Buscar..." v-model="busca">
                            <button class="px-2 rounded-r-lg focus:outline-none hover:bg-light-gray">
                                <router-link :to="'/busca/'+busca">
                                    <svg-icon icon="search" class="text-black"></svg-icon>
                                </router-link>
                            </button>
                        </div>
                    </li>
                </ul>
                <div class="social">
                    <a href="https://twitter.com/sp_ugt" target="_blank" class="social-link">
                        <svg-icon icon="twitter"></svg-icon>
                    </a>
                    <a href="https://www.facebook.com/ugtsp" target="_blank" class="social-link">
                        <svg-icon icon="facebook"></svg-icon>
                    </a>
                    <a href="https://youtube.com/channel/UCeMrGI2nKGKFQWQ0DEIUUVg" target="_blank" class="social-link">
                        <svg-icon icon="youtube"></svg-icon>
                    </a>
                    <a href="/sistema" class="social-link">
                        <svg-icon icon="tv"></svg-icon>
                    </a>
                </div>
            </nav>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'menu-mobile',
    props: ['menuIsOpen'],
    data() {
        return {
            noticiaDropdown: false,
            intitucioanlDropdown: false,
            busca: ''
        }
    },
    methods: {
        closeMenu(event) {
            if (event.target === event.currentTarget) {
                this.$emit('update:menuIsOpen', !this.menuIsOpen);
            }
        },
        close() {
            this.$emit('update:menuIsOpen', !this.menuIsOpen);
        }
    }
}
</script>

<style lang="scss" scoped>
.menu-mobile {
    @apply w-full h-screen fixed z-50 top-0;
    background: rgba(0, 0, 0, 0.4);
    nav {
        @apply w-10/12 h-screen fixed top-0 right-0 flex flex-col overflow-y-scroll bg-black;
        .close {
            @apply flex justify-end p-4;
            svg {
                width: 16px;
                height: 16px;
                color: #fff;
            }
        }
        ul {
            @apply flex-1;
            li {
                @apply my-2 mx-0;
                a {
                    @apply text-white;
                }

                .menu-mobile-dropdown {
                    @apply flex flex-col my-4 mx-0 p-4 pr-0;
                    border-bottom: 1px solid #fff;
                    border-top: 1px solid #fff;
                    a {
                        margin: 0.2rem 0;
                    }
                }
            }
        }
    }

    .social {
        @apply flex items-center justify-around p-4;
        a svg {
            @apply text-white;
            width: 18px;
            height: 18px;
        }
    }

    .search-bar {
        width: 200px;
        @apply mt-3;
        input {
            @apply w-full rounded-lg px-2 py-1 outline-none text-black;
            &:focus {
                @apply outline-none;
            }
        }
    }
}
.disable {
    @apply hidden;
}

</style>
